/*eslint-disable*/
import { UncontrolledTooltip } from 'reactstrap';

import UserAvatar1 from '../../../assets/images/public/avatar1.svg';
import UserAvatar2 from '../../../assets/images/public/avatar2.svg';
import UserAvatar3 from '../../../assets/images/public/avatar3.svg';
import UserAvatar4 from '../../../assets/images/public/avatar4.svg';
import UserAvatar5 from '../../../assets/images/public/avatar5.svg';
import UserAvatar6 from '../../../assets/images/public/avatar6.svg';
import UserAvatar7 from '../../../assets/images/public/avatar7.svg';
import UserAvatar8 from '../../../assets/images/public/avatar8.svg';
import UserAvatar9 from '../../../assets/images/public/avatar9.svg';
import UserAvatar10 from '../../../assets/images/public/avatar10.svg';

import './upvoters.scss';

const images = [UserAvatar1, UserAvatar2, UserAvatar3, UserAvatar4, UserAvatar5, UserAvatar6, UserAvatar7, UserAvatar8, UserAvatar9, UserAvatar10];

const Upvoters = ({
    upvoters,
    source,
}) => {
    const cappedVoterLimit = 9;

    const getNumberStyle = (totalVoters) => {
        let _left = 0;
        if (totalVoters > 1) {
            _left = totalVoters * 20;

            return _left;
        };
    }

    const getImage = (index) => {
        if (index < 10) {
            return images[index];
        }
        // use random umber between 1 and 10
        const randomNumber = Math.floor(Math.random() * 10) + 1;
        return images[randomNumber];
    }

    return (
        <div className="f-voters-row">
            {
                upvoters?.length > 0 ? (
                    <div className="upvoters-list">
                        {
                            upvoters.slice(0, cappedVoterLimit).map((upvoter, index) => (
                                <span key={upvoter.name + index} className="upvoter_circle" style={{ left: `${index * 25}px` }}>
                                    {/* <span className="__initials">{upvoter.name[0]}</span> */}
                                    <img src={getImage(index + 1)} alt="user avatar" id={`upvoter-${index + 1}`} />
                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`upvoter-${index + 1}`}
                                    >
                                        {upvoter.name}
                                    </UncontrolledTooltip>
                                </span>
                            ))
                        }
                        {
                            upvoters?.length > cappedVoterLimit && (
                                <span className="upvoter_circle" style={{ left: `${getNumberStyle(11)}px` }}>
                                    <span className='__initials'>+{upvoters?.length - (cappedVoterLimit + 1)}</span>
                                </span>
                            )
                        }
                    </div>
                ) : (
                    <p>No upvotes yet</p>
                )
            }
        </div>
    );
};

export default Upvoters;


